<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <!-- No Color feature means nothing can be added. Say so and stop. -->
    <div *ngIf="colorFeature == null" class="p-4 text-sm" style="color: var(--p-red-500, #ef4444)">
      {{ errorMessage }}
    </div>

    <ng-container *ngIf="colorFeature != null">
      <div class="p-3">
        <div class="qb-detail-card qb-primary-tint p-4">
          <table class="qb-info-table w-full">
            <tr>
              <td class="label">Manufacturer</td>
              <td class="value">{{ params.manufacturerName }}</td>
            </tr>
            <tr>
              <td class="label">Style</td>
              <td class="value">{{ params.styleCode }}</td>
            </tr>
            <tr>
              <td class="label">Colors selected</td>
              <td class="value">{{ checkedCount }} of {{ rows.length }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="px-3 pb-2 flex items-center gap-3">
        <span class="text-sm">Select the colors to add to the '{{ colorFeature.name }}' list.</span>
        <button pButton type="button" class="p-button-text p-button-sm ml-auto" (click)="checkAll(true)">
          <span>Select all</span>
        </button>
        <button pButton type="button" class="p-button-text p-button-sm" (click)="checkAll(false)">
          <span>Clear</span>
        </button>
      </div>

      <div class="flex-1 min-h-0 overflow-auto px-3 pb-3">
        <div
          *ngFor="let r of rows"
          class="flex items-center gap-3 p-2 border-b cursor-pointer"
          (click)="r.isChecked = !r.isChecked"
        >
          <p-checkbox [(ngModel)]="r.isChecked" [binary]="true" [inputId]="'c' + r.name" />
          <span class="flex-1">{{ r.name }}</span>
        </div>
      </div>

      <div *ngIf="errorMessage" class="px-3 pb-2 text-sm" style="color: var(--p-red-500, #ef4444)">
        {{ errorMessage }}
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="!canSave" [loading]="isSaving" (click)="onOk()">
      <span>Add Colors</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="onCancel()">
      <span>Cancel</span>
    </button>
  </div>
</ng-template>
